export enum MemberPaymentStatus {
    Unspecified = 0,
    Payed = 1,
    UnPayed = 2,
    UnPayedLastYear = 3,
}
